import axios from 'axios';
import {getStorageUserToken} from "./UserService";
import * as constants from '../constantsuniodonto';

const API_URL = constants.API_URL;

export const create = async (data) => {
  return axios.post(`${API_URL}/plans`, data,
    {
      headers: { Authorization: `Bearer ${getStorageUserToken()}` }
    });
};

export const fetch = async () => {
  return axios.get(`${API_URL}/plans`,
    {
      headers: { Authorization: `Bearer ${getStorageUserToken()}` }
    });
};

export const get = async (id) => {
  return axios.get(`${API_URL}/plans/plan/${id}`,
    {
      headers: { Authorization: `Bearer ${getStorageUserToken()}` }
    });
};

export const search = async (query) => {
  return axios.get(`${API_URL}/plans/search?q=${query}`,
    {
      headers: { Authorization: `Bearer ${getStorageUserToken()}` }
    });
};

export const update = async (data) => {
  return axios.put(`${API_URL}/plans`, data,
    {
      headers: { Authorization: `Bearer ${getStorageUserToken()}` }
    });
};

export const remove = async (id) => {
  return axios.delete(`${API_URL}/plans/${id}`,
    {
      headers: { Authorization: `Bearer ${getStorageUserToken()}` }
    });
};